<template>
  <div class="col-md-12 p-0">
    <b-card>
      <b-row v-if="item">
        <b-col>
          <h3 class="font-weight-bolder">
            <b-link
              class="btn btn-outline-primary"
              to="/market"
            >
              <FeatherIcon icon="ChevronLeftIcon" />
              {{ $t("go_back_to_market") }}
            </b-link>
          </h3>
        </b-col>
        <b-col style="display: flex; align-items: center; justify-content: right;">
          <h3 class="font-weight-bolder" style="margin-top: 5px; ">
            {{ $t("invoice_id") }} : I-{{ item.id }}
          </h3>
        </b-col>
      </b-row>
    </b-card>

    <form-wizard
        ref="formWizard"
        v-model.trim="tab"
        color="#1586c4"
        :title="null"
        :subtitle="null"
        shape="square"
        finish-button-text="Submit"
        back-button-text="Previous"
        class="mb-3"
        @on-complete="submit"
    >
      <template
        slot="step"
        scope="props"
      >
        <wizard-step
          :key="props.tab.title"
          :tab="props.tab"
          :transition="props.transition"
          :index="props.index"
        />
      </template>
      <template
        slot="footer"
        slot-scope="props"
        align="end"
      >
        <div
          v-if="buyerError"
          class="col-md-12 mb-2 justify-end text-end align-end text-danger"
          align="end"
        >
          {{ $t(buyerError) }}
        </div>
        <div class="d-flex justify-content-between col-md-12 pr-0">
          <div>
            <b-button
              v-if="props.activeTabIndex == 1"
              size="md"
              variant="outline-primary"
              class="mr-1 mb-2"
              @click="cancelButton(props)"
            >
              <feather-icon
                icon="ArrowLeftIcon"
                size="14"
              />
              <span class="pb-1" >
                {{ $t("back") }}
              </span>
            </b-button>
          </div>
          <div
            v-if="props.activeTabIndex != 2"
            align="end"
          >
            <b-button
              v-if="props.activeTabIndex == 0 && initialFractions != 100"
              id="buyInvoice"
              size="md"
              class="mb-1"
              variant="primary"
              :disabled="loader"
              @click="checkForBalance(props)"
            >
              <feather-icon
                icon="ArrowRightCircleIcon"
                size="14"
              />
              {{ $t("buy") }}
            </b-button>

          </div>
        </div>
      </template>
      <!-- invoice details tab -->
      <tab-content :title="$t('invoice_details')">
        <invoice-details
          :invoice="item"
          :statistics="supportTrackerRadialBar"
          :rating-status="ratingStatus"
        />
      </tab-content>
      <!-- invest tab -->
      <tab-content :title="$t('invest')">
        <invest
            :invoice="item"
            @setSlider="setSlider"
            @disableBuy="disableBuy"
            @modalValues="modalValues"
            @buy-invoice="buyInvoice"
            :wizard-active-index="tab"
            :initial-fractions="initialFractions"
            :disable-button="disableButton"
        />
      </tab-content>

      <!-- confirm tab  -->
      <tab-content :title="$t('confirmation')">
        <h1 class="">
          <Confirmation
            :slider="slider"
            :invoice-data="invoiceData"
          />
        </h1>
      </tab-content>
    </form-wizard>

    <b-row
      v-if="item && (activeTab == 0 || activeTab == 2)"
      class="mb-0"
    >
      <b-col md="12">
        <b-card
          class="card-transaction"
          no-body
        >
          <b-card-body class="row">
            <div class="col-xl-4 col-lg-4 col-md-6 mb-1 mt-1">
              <b-media no-body>
                <b-media-body>
                  <h6 class="transaction-title font-weight-bolder font-1rem">
                    {{ $t("assets_class") }}:

                    <span
                      class="font-weight-normal ml-1 font-1rem"
                    >Invoice Receivables</span>
                  </h6>

                </b-media-body>
              </b-media>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 mb-1 mt-1">
              <b-media no-body>
                <b-media-body>

                  <h6 class="transaction-title font-weight-bolder font-1rem">

                    {{ $t('marketplace_origin_title') }}:

                    <span class="font-weight-normal ml-1 font-1rem">
                      {{ $t('seller') }} ( {{ this.item.company.country.name }} ) {{ $t('marketplace_origin_text1') }} ({{ this.item.debtor.country.name }})
                    </span>

                  </h6>

                </b-media-body>
              </b-media>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 mb-1 mt-1">
              <b-media no-body>
                <b-media-body>
                  <h6 class="transaction-title font-weight-bolder font-1rem">
                    {{ $t("currency") }}:

                    <span class="font-weight-normal ml-1 font-1rem">{{ item.currency.name }}</span>
                  </h6>
                </b-media-body>
              </b-media>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 mb-1 mt-1">
              <b-media no-body>
                <b-media-body>
                  <h6 class="transaction-title font-weight-bolder font-1rem">
                    {{ $t("factoring_type") }}:
                    <span class="font-weight-normal ml-1 font-1rem">
                      {{ item && (item.is_reverse == 1 || item.recourse == 1) ? $t('Silent') : $t('Open') }}
                      <feather-icon
                        v-b-tooltip.hover
                        icon="HelpCircleIcon"
                        role="button"
                        :title="item && (item.is_reverse == 1 || item.recourse == 1) ? $t('silent_tooltip') : $t('open_tooltip')"
                        size="18"
                      />
                    </span>
                    <span class="font-weight-normal ml-1 font-1rem">
                      <span>
                        {{ item && item.is_reverse == 1 ? $t("Reverse") : ( item && item.recourse == 0 ? $t("Non Recourse") : $t("Recourse")) }}
                      </span>
                      <feather-icon
                        v-b-tooltip.hover
                        icon="HelpCircleIcon"
                        role="button"
                        :title="item && item.is_reverse == 1 ? $t('reverse_tooltip') : ( item && item.recourse == 0 ? $t('non_recourse_tooltip') : $t('recourse_tooltip'))"
                        size="18"
                      />
                    </span>
                  </h6>
                </b-media-body>
              </b-media>
            </div>

            <div
              v-if="item && item.collateral"
              class="col-xl-4 col-lg-4 col-md-6 mb-1 mt-1"
            >
              <b-media no-body>
                <b-media-body>
                  <h6 class="transaction-title font-weight-bolder font-1rem">
                    {{ $t("collateral(1)") }}:

                    <span class="font-weight-normal ml-1 font-1rem">{{
                      $t("intermediar")
                    }}</span>
                  </h6>
                </b-media-body>
              </b-media>
            </div>
            <div
              v-if="item && item.collateral"
              class="col-xl-4 col-lg-4 col-md-6 mb-1 mt-1 font-1rem"
            >
              <b-media no-body>
                <b-media-body>
                  <h6 class="transaction-title font-weight-bolder font-1rem">
                    {{ $t("collateral_value_remaining") }}:
                    <span class="font-weight-normal ml-1 font-1rem">120%</span>
                  </h6>
                </b-media-body>
              </b-media>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-card v-if="activeTab < 2 && item && item.fractions && item.fractions.length > 0">
      <div class="col-md-12 mt-1 pl-0 mr-1">
        <div align="start" class="font-weight-bolder text--gray mb-2">
          {{ $t("fractions_bought") }}
        </div>

        <b-table
          id="fraction-table"
          striped
          :items="item.fractions"
          :fields="fractionFields"
          responsive
        >
          <template #head()="scope">
            <div class="text-nowrap">
              {{ $t(scope.label) }}
            </div>
          </template>
          <template #cell(currency)="">
            <span>CHF</span>
          </template>
          <template #cell(buyer)="data">
            <span v-if="data.item.company && data.item.company.name">{{
              data.item.company.name
            }}</span>
            <span
              v-else-if="data.item.company.user && data.item.company.user[0]"
            >{{ data.item.company.user[0].name }}
              {{ data.item.company.user[0].last_name }}</span>
          </template>
          <template #cell(invoice_id)="data">
            <span
              v-if="data"
              style="width:55px;"
              class="badge badge-light-primary"
            > I-{{ data.value }} </span>
            <span v-else>-</span>
          </template>

          <template #cell(fraction)="data">
            <span v-if="data.item.fraction"> {{ data.item.fraction }}% </span>
            <span v-else>-</span>
          </template>
          <template #cell(amount)="data">
            <span v-if="data.item.amount">
              {{ data.item.amount | formatAmount }}
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(discount)="data">
            <span v-if="data.item.discount">
              {{ data.item.discount | formatAmount }}
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(hive_fee)="data">
            <span v-if="data.item">
              {{ data.item.hive_fee | formatAmount }}
            </span>
            <span v-else>-</span>
          </template>
          <template #cell(net_return)="data">
            <span v-if="data.item">
              {{ data.item.net_return | formatAmount }}
            </span>
            <span v-else>-</span>
          </template>

          <template #cell(created_at)="data">
            <span v-if="data.item.created_at">{{
              data.item.created_at | formatDateMinutes
            }}</span>
            <span v-else>-</span>
          </template>

          <template #cell(status)="data">
            <span>{{ getStatusLabel(data.item) }}</span>
          </template>
        </b-table>
      </div>
    </b-card>
  </div>
</template>
<script>
import {FormWizard, TabContent, WizardStep} from 'vue-form-wizard'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import InvoiceStatus from '@/components/invoices/InvoiceStatus'
import {$themeColors} from '@themeConfig'
import {CurrencyAmountFormat} from '@core/utils/CurrencyAmountFormat'
import Invest from './Invest.vue'
import Confirmation from './Confirmation.vue'
import InvoiceDetails from './InvoiceDetails.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    InvoiceStatus,
    InvoiceDetails,
    Invest,
    Confirmation,
    WizardStep,
  },
  data() {
    return {
      disableBuyFullButton: false,
      buyFull: false,
      loader: false,
      item: null,
      tab: 0,
      slider: 0,
      initialFractions: 0,
      invoiceData: [],
      supportTrackerRadialBar: {},
      ratingStatus: '',
      activeTab: 0,
      buyerError: '',
      checkAmount: '',
      checkFunds: '',
      modalText: '',
      modalTitle: '',
      approveModalAction: null,
      myProps: null,
      modal: false,
      disableButton: true,
      buyModalInfo: {
        amount: '',
        fee: '',
        total: '',
        net_return: '',
      },
      fractionFields: [
        {
          label: 'invoice_id',
          align: 'start',
          key: 'invoice_id',
          thClass: 'bg-light-primary text-dark',
        },
        {
          label: 'datetime',
          align: 'start',
          key: 'created_at',
          thClass: 'bg-light-primary text-dark',
        },
        {
          label: 'fraction',
          align: 'start',
          key: 'fraction',
          sortable: false,
          thClass: 'bg-light-primary text-dark',
        },
        {
          label: 'amount',
          align: 'right',
          key: 'amount',
          sortable: false,
          thClass: 'bg-light-primary text-dark text-right',
          tdClass: 'text-right',
        },
        {
          label: 'status',
          key: 'status',
          customSlot: true,
          sortable: false,
          thClass: 'bg-light-primary text-dark',
        },
      ],
    }
  },

  created() {
    this.getInvoice()
  },

  methods: {
    amountFormat(amount, currency) {
      return CurrencyAmountFormat(amount, currency)
    },

    modalValues(amount, fee, net_return, currency) {
      this.buyModalInfo = {
        amount,
        fee,
        net_return,
        currency,
      }
    },

    disableBuy(butt) {
      if (butt != undefined) {
        this.disableButton = butt
      }
    },

    changeModalInfo(props) {
      this.props = props
      this.modal = true
    },

    cancelButton(props) {
      this.buyerError = ''
      if (props.activeTabIndex == 2) {
        this.$router.push('/market')
        this.activeTab = 2
      } else if (props.activeTabIndex == 1) {
        props.prevTab()
        this.activeTab = 0
      } else {
        props.prevTab()
        this.activeTab = 1
      }
    },

    setSlider(slider) {
      this.slider = slider
    },

    checkForBalance(props) {
      this.buyerError = ''
      props.nextTab()
      this.tab = 2
      this.activeTab = 2
    },

    buyInvoice(requestData, selectedPercent) {
      this.$http.post(`/market/invoice/${this.$route.params.id}/buy`, requestData).then(res => {
        if (res) {
          this.loader = false
          this.activeTab = 2
          this.tab = 2
          this.invoiceData = [
            { text: 'invoice', value: `I-${this.item.id}` },
            { text: 'seller', value: `C-${this.item.company_id}` },
            { text: 'debtor', value: `C-${this.item.debtor.id}` },
            { text: 'investment_amount', value: `${this.item.currency.name} ${res.data.value.bought.amount}` },
            { text: 'expected_net_return', value: `${this.item.currency.name} ${res.data.value.bought.net_return}` },
          ]

          this.slider = selectedPercent;
          const props = this.$refs.formWizard || { nextTab: () => { this.tab = 2 } };

          if (selectedPercent != 0 && props) {
            props.nextTab()
          }
        }
      })
    },

    goNext(slider, amount, funds) {
      this.checkAmount = amount
      this.checkFunds = funds
      document.getElementById('buyInvoice').click()
    },

    changeTab(tab) {
      tab.activeTabIndex++
      this.tab++
    },

    getInvoice() {
      this.$http.post(`/market/invoice/${this.$route.params.id}`)
        .then(res => {
          if (res) {
            this.item = res.data.value
            const doc = document.querySelectorAll('.wizard-nav-pills > li > a ')

            doc.forEach(el => {
              el.href = '#'
            })
            if (this.item) {
              this.item.fractions.map(el => {
                this.initialFractions += el.fraction
              })

              if (this.item.recourse == 0) {
                this.recourse = 0
              } else {
                this.recourse = 1
              }

              if (this.item.due_date == null || this.item.amount == '0.00') {
                this.disabledFields = false
              } else {
                this.disabledFields = true
              }

              this.load = false

              let invoice_scoring = this.item.scoring;

              if (invoice_scoring && invoice_scoring.rating) {
                const rating = this.item.scoring.rating;

                if (rating === 'AAA') {
                  this.ratingStatus = 'very_low_default_risk'
                } else if (['AA+', 'AA', 'AA-'].includes(rating)) {
                  this.ratingStatus = 'low_default_risk'
                } else if (['A', 'A+', 'A-'].includes(rating)) {
                  this.ratingStatus = 'moderate_default_risk'
                } else if (['BBB', 'BBB+', 'BBB-'].includes(rating)) {
                  this.ratingStatus = 'slightly_increased_default_risk'
                } else if (['BB', 'BB+'].includes(rating)) {
                  this.ratingStatus = 'elevated_default_risk'
                } else if (rating === 'BB-') {
                  this.ratingStatus = 'high_default_risk'
                }
              }

              this.supportTrackerRadialBar = {
                series: [this.item.weight_score],
                chartOptions: {
                  plotOptions: {
                    radialBar: {
                      size: 250,
                      offsetY: 20,
                      startAngle: -150,
                      endAngle: 150,
                      hollow: {
                        size: '60%',
                      },
                      track: {
                        background: '#fff',
                        strokeWidth: '100%',
                      },
                      dataLabels: {
                        show: true,
                        name: {
                          offsetY: 10,
                          color: '#5e5873',
                          fontSize: '2.3rem',
                          show: true,
                        },
                        value: {
                          offsetY: 15,
                          color: '#5e5873',
                          fontSize: '3rem',
                          show: false,
                        },
                      },
                    },
                  },
                  colors: [$themeColors.success],
                  fill: {
                    type: 'gradient',
                    gradient: {
                      shade: 'dark',
                      type: 'horizontal',
                      shadeIntensity: 0.5,
                      gradientToColors: [$themeColors.primary],
                      inverseColors: true,
                      opacityFrom: 1,
                      opacityTo: 1,
                      stops: [0, 100],
                    },
                  },
                  stroke: {
                    dashArray: 8,
                  },
                  labels: [
                    this.item.scorings && this.item.scorings.length > 0
                      ? this.item.scorings[0].rating
                      : '',
                  ],
                },
              }
            }
          }
        })
    },


    getStatusLabel(item) {
      const transaction = item.transactions?.[0];

      if (!transaction) return '-';

      const userCompanyId = this.$store.state.auth.user.company_id;

      if (item.status === "purchased") {
        return this.$t('purchased');
      } else if (transaction.company_id === userCompanyId) {
        return this.$t('option');
      } else {
        return this.$t('option_of_others');
      }
    },
    submit() {},
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style>
</style>
